import firebase from "firebase/app";
import { useRef, useEffect } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import ChatMessage from "./ChatMessage";
import { useParams } from "react-router";
import ParamsType from "../types/Types";

const Messages = () => {
  const db = firebase.firestore();
  const { id } = useParams<ParamsType>();
  const userUid = firebase.auth()?.currentUser?.uid;

  const messagesDB = id ? db.collection(`${creatrChatID()}` || "") : db.collection("messages");

  function creatrChatID() {
    if (userUid != null) {
      const chatterID = userUid;
      const chateeID = id;
      const chatIDpre = [];
      chatIDpre.push(chatterID);
      chatIDpre.push(chateeID);
      chatIDpre.sort();
      return chatIDpre.join("_");
    }
  }
  const query = messagesDB.orderBy("createdAt").limitToLast(15);

  const [messages] = useCollectionData(query, { idField: "id" });

  const scrollToBottom = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    scrollToBottom.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  function deleteMessage(messageId: string, messageUid: string, event: React.MouseEvent<HTMLDivElement>) {
    event?.preventDefault();
    if (userUid !== undefined && userUid === messageUid) {
      messagesDB.doc(messageId).delete();
    }
  }

  function changeMessage(messageId: string, messageUid: string, messageText: string, event: any) {
    event?.preventDefault();
    if (userUid !== undefined && userUid === messageUid) {
      messagesDB.doc(messageId).update({ text: messageText });
    }
  }

  function setMessageLike(messageId: string, isLiked: boolean) {
    messagesDB.doc(messageId).update({ isLiked: !isLiked });
  }

  function showMessages() {
    const newMessages = messages?.map((message) => (
      <div key={message.id}>
        <ChatMessage photoURL={message.photoURL} isLiked={message.isLiked} displayName={message.displayName} uid={message.uid} text={message.text} img={message.img} id={message.id} deleteMessage={deleteMessage} changeMessage={changeMessage} setMessageLike={setMessageLike} />
      </div>
    ));

    return newMessages;
  }

  return (
    <>
      <main>
        <div className="messages-background">
          <div className="messages-area">{showMessages()}</div>
        </div>
        <span ref={scrollToBottom}></span>
      </main>
    </>
  );
};

export default Messages;
